define('contentLayout',['helpers', 'utils'], function(helpers, utils) {
    'use strict';

    function ContentLayout(options) {

        options = options || {};

        this.imageURL = options.imageURL || '';

        this.alignment = options.alignment || {
            horizontal: {
                aside: '',
                content: ''
            },
            vertical: {
                aside: '',
                content: ''
            }
        };

        this.container = options.container || document.body;
        this.component = options.component || false;
        this.layoutWidth = options.layoutWidth || 0;
        this.layoutImage = null;
        this.layoutLargeComponent = null;
        this.layoutElements = helpers.misc.cloneObject(options.layoutElements || {});
        this.layoutTemplate = options.layoutTemplate || 0;
        this.mobile = options.mobile || {};
        this.missing = options.missing || false;
        this.singleColumn = options.singleColumn || false;
        this.separator = options.separator || false;


        this.init();
    }

    ContentLayout.prototype.getFirstProperty = function(obj, colNo, rowNo, dir) {
        for (var i in obj) {
            if (obj.hasOwnProperty(i) && obj[i][0][0] === colNo && obj[i][0][1] === rowNo) {
                return i;
            }
        }

        switch(dir) {
            case 'row':
                if (rowNo < this.rowsTotal) {
                    return this.getFirstProperty(obj, colNo, ++rowNo, dir);
                } else if (rowNo === this.rowsTotal && colNo < this.colsTotal) {
                    return this.getFirstProperty(obj, ++colNo, 1, dir);
                }
                break;
            default:
                if (colNo < this.colsTotal) {
                    return this.getFirstProperty(obj, ++colNo, rowNo, dir);
                } else if (colNo === this.colsTotal && rowNo < this.rowsTotal) {
                    return this.getFirstProperty(obj, 1, ++rowNo, dir);
                }
        }

        return '';
    };

    ContentLayout.prototype.parseSections = function(obj, last, dir, section) {
        var pos = {
                a: 0,
                b: 0
            };

        last = last || -1;
        section = section || {
            main: {}
        };
        section.secondary = {};

        for (var i in obj) {
            if (obj.hasOwnProperty(i) && !section.main.hasOwnProperty(i)) {
                pos.a = (dir === 'row') ? obj[i][0][1] : obj[i][0][0];
                pos.b = (dir === 'row') ? obj[i][1][1] : obj[i][1][0];

                if (pos.a > last) {
                    if (!section.secondary.hasOwnProperty(i)) {
                        section.secondary[i] = obj[i]; //.slice(0);
                    }
                    continue;
                }

                section.main[i] = obj[i]; //.slice(0);

                if (pos.b > last) {
                    last = pos.b;
                    section = this.parseSections(obj, last, dir, section);
                }
            }
        }

         // Check if columns could be merged to one row
        if (dir === 'col' && Object.keys(section.main).length > 1 && Object.keys(section.secondary).length > 1 && last < this.colsTotal) {
            if (this.isColsMergable(section, last, dir)) {
                section = this.parseSections(obj, ++last, dir, section);
            }
        }

        return section;
    };

    ContentLayout.prototype.isColsMergable = function(section, last, dir)  {
        var main = section.main,
            next = this.parseSections(section.secondary, ++last, dir),
            rowPositios = function(obj) {
                var str = '',
                    arr = [];

                for(var i in obj) {
                    if (obj.hasOwnProperty(i)) {
                        str = obj[i][0][1] + '-' + obj[i][1][1];

                        if (arr.indexOf(str) === -1) {
                            arr.push(str);
                        }
                    }
                }

                return arr.sort();
            };

        return (rowPositios(main).equals(rowPositios(next.main))) ? true : false;
    };

    ContentLayout.prototype.updateCol = function(col, content) {
        var obj = null,
            firstRow,
            lastRow,
            cssClass = '';

        var str = (Array.isArray(content)) ? (content[0]) ? content[0] : '' : (content) ? content : '',
            section  = str.toLowerCase();

        obj = (this.layoutElements[str] && Array.isArray(this.layoutElements[str])) ? {str: this.layoutElements[str].slice(0)} : null;

        firstRow = (obj) ? this.firstPoint(obj, 'row') : 0;
        lastRow = (obj) ? this.lastPoint(obj, 'row') : 0;

        if (firstRow === 1 && lastRow === this.rowsTotal) {
            cssClass = 'col-offset';
        } else if (firstRow === 1) {
            cssClass = 'col-offset-top';
        } else if (lastRow === this.rowsTotal) {
            cssClass = 'col-offset-bottom';
        }

        if (cssClass) {
            col.className += ' ' + cssClass;
        }

        if (Array.isArray(content)) {
            for (var i = 0; i < content.length; i++) {
                // var row = this.createRow(col);
                this.createColumn(this.createRow(col), content[i].toLowerCase());
                // column.innerHTML += '<!-- ko template: { name: function() { return $root.layout.templateID(\'layout\', \'' + content[i].toLowerCase() + '\', \'ko-template-layout-' + content[i].toLowerCase() + '\'); } } --> <!-- /ko -->';
            }

        } else if (section) {
            col.setAttribute('data-bind', 'template: { name: function() { return $root.layout.templateID(\'layout\', \'' + section + '\', \'ko-template-layout-' + section + '\'); } }');

            if (this.mobile.enabled) {
                this.setMobileProp(col, section);
            }
        }
    };

    ContentLayout.prototype.setMobileProp = function(col, section) {
        var index = -1,
            order = this.mobile.order && Array.isArray(this.mobile.order) ? this.mobile.order.map(function(str) {
                return str.toLowerCase();
            }) : [],
            fixed = this.mobile.fixed && Array.isArray(this.mobile.fixed) ? this.mobile.fixed.map(function(str) {
                return str.toLowerCase();
            }) : [],
            hidden = this.mobile.hidden && Array.isArray(this.mobile.hidden) ? this.mobile.hidden.map(function(str) {
                return str.toLowerCase();
            }) : [];

        section = section.toLowerCase();

        if (section === 'componentdefault') {
            col.classList.add('js-mobile-container');
            return;
        }

        index = order.indexOf(section);

        if (index !== -1) {
            col.setAttribute('data-order', index);
        }

        if (fixed.indexOf(section) !== -1) {
            col.classList.add('l-mobile-fixed');
        }

        if (hidden.indexOf(section) !== -1) {
            col.classList.add('l-mobile-hidden');
        }
    };

    ContentLayout.prototype.section = function(cords, sections) {
        var total = 0,
            sub = []

        for (var prop in sections) {
            if (cords.equals(sections[prop])) {
                total++;
                sub.push(prop);
            }
        }

        return {
            isSingle: (total === 1) ? true : false,
            sub: sub
        };
    }

    /**
    * Creates column & appends it to row
    * @param {Node} row - row to append To
    * @return {Node} created column
    */
    ContentLayout.prototype.createColumn = function(row, content, obj, grid) {
        var col = document.createElement('div'),
            len = this.colsLength(obj),
            cssClass = (grid && len > 0) ? 'layout-col layout-col-' + len + '-' + grid : 'layout-col';

        col.setAttribute('class', cssClass);

        if (Array.isArray(content)) {
            this.updateCol(col, content);
        } else if (content && content.indexOf('e-') !== 0) {
            this.updateCol(col, content);
        }

        row.appendChild(col);

        return col;
    };

    ContentLayout.prototype.createColumns = function(row, sections) {
        var arr = Object.keys(sections).sort(function(a, b){
                return sections[a][0][0] - sections[b][0][0];
            }),
            prev = [],
            section = {};

        for (var i = 0; i < arr.length; i++) {
            if (!sections[arr[i]].equals(prev)) {
                section = this.section(sections[arr[i]], sections);

                if (section.isSingle) {
                    this.createColumn(row, arr[i], {i: sections[arr[i]]}, this.colsLength(sections));
                } else {
                    this.createColumn(row, section.sub, {i: sections[arr[i]]}, this.colsLength(sections));
                }
            }

            prev = sections[arr[i]];
        }
    };

    /**
    * Creates row & appends it to column
    * @param {Node} row - row to append To
    * @return {Node} created row
    */
    ContentLayout.prototype.createRow = function(col) {
        var row = document.createElement('div');
        row.setAttribute('class', 'layout-row');
        col.appendChild(row);
        return row;
    };

    ContentLayout.prototype.createRows = function(col, section) {
        var i = 0,
            row,
            arr = Object.keys(section).sort(function(a, b){
                return section[a][1][1] - section[b][1][1];
            }),
            len = arr.length;

        for( ; i < len; i++) {
            if (len === 1) {
                if (arr[i] && arr[i].indexOf('e-') !== 0) {
                    this.updateCol(col, arr[i]);
                }
            } else {
                row = this.createRow(col);
                this.createColumn(row, arr[i], {i: section[arr[i]]}, this.colsLength(section));
            }
        }
    };

    ContentLayout.prototype.flatten = function(obj) {
        var i,
            arr = [];

        for (i in obj){
            if (obj.hasOwnProperty(i)) {
                arr = arr.concat(obj[i]);
            }
        }

        return arr;
    };

    ContentLayout.prototype.lastRendered = function(obj) {
        var template = (this.layoutTemplate) ? this.layoutTemplate.toLowerCase() : '',
            rowsTotal = (template === 'largecomponent') ? this.lastPoint(this.layoutElements, 'row') : this.rowsTotal;

        for (var i in obj) {
            if (obj.hasOwnProperty(i) && obj[i][1][1] === rowsTotal) {
                return true;
            }
        }

        return false;
    };

    ContentLayout.prototype.firstPoint = function(obj, dir) {
        var pos,
            arr = this.flatten(obj);

        return arr.reduce(function(max, arr) {
            pos = (dir === 'row') ? arr[1] : arr[0];
            return Math.min(max, pos);
        }, +Infinity);
    };

    ContentLayout.prototype.lastPoint = function(obj, dir) {
        var pos,
            arr = this.flatten(obj);

        return arr.reduce(function(max, arr) {
            pos = (dir === 'row') ? arr[1] : arr[0];
            return Math.max(max, pos);
        }, -Infinity);
    };

    ContentLayout.prototype.colsLength = function(obj) {
        var arr = this.flatten(obj),
            min = Infinity,
            max = -Infinity;

        min = arr.reduce(function(min, arr) {
            return Math.min(min, arr[0]);
        }, Infinity);

        max = arr.reduce(function(max, arr) {
            return Math.max(max, arr[0]);
        }, -Infinity);

        return max - min + 1;
    };

    ContentLayout.prototype.rowsLength = function(obj) {
        var arr = this.flatten(obj),
            min = Infinity,
            max = -Infinity;

        min = arr.reduce(function(min, arr) {
            return Math.min(min, arr[1]);
        }, Infinity);

        max = arr.reduce(function(max, arr) {
            return Math.max(max, arr[1]);
        }, -Infinity);

        return max - min + 1;
    };

    ContentLayout.prototype.separateColumnsNo = function(sections) {
        var arr = [],
            str = '';

        for (var prop in sections) {
            str = sections[prop][0][0] + '-' + sections[prop][0][1] + '-' + (sections[prop][1][0] - sections[prop][0][0]);

            if (arr.indexOf(str) === -1) {
                arr.push(str);
            }
        }

        return arr.length;

    };

    ContentLayout.prototype.separateSectionsNo = function(sections) {
        var arr = [],
            str = '';

        for (var prop in sections) {
            str = (sections[prop]) ? JSON.stringify(sections[prop]) : '';

            if (str && arr.indexOf(str) === -1) {
                arr.push;
            }
        }

        return arr.length;
    };

    ContentLayout.prototype.colSection = function(obj, colNo, row, grid) {
        var col,
            prop = this.getFirstProperty(obj, colNo, 1, 'row'),
            last = (prop) ? obj[prop][1][0] : 0,
            section = {
                main: {},
                secondary: {}
            };

        if (!prop) {
            return;
        }

        section = this.parseSections(obj, last, 'col');

        if (Object.keys(section.main).length) {

            col = this.createColumn(row, '', section.main, grid);

            // if (Object.keys(section.main).length < 3) {
            if (this.separateSectionsNo(section.main) < 3) {
                this.createRows(col, section.main, grid);
            } else {
                this.rowSection(section.main, 1, col);
            }

        }

        if (Object.keys(section.secondary).length && last < this.colsTotal) {
            this.colSection(section.secondary, ++last, row, grid);
        }
    };

    ContentLayout.prototype.rowSection = function(obj, rowNo, col) {
        var row,
            prop = this.getFirstProperty(obj, 1, rowNo),
            last = (prop) ? obj[prop][1][1] : 0,
            section = {
                main: {},
                secondary: {}
            };

        if (!prop) {
            return;
        }

        section = this.parseSections(obj, last, 'row');

        if (Object.keys(section.main).length) {
            row = (col) ? this.createRow(col) : this.createRow(this.container);

            if (this.separateColumnsNo(section.main) < 3) {
                this.createColumns(row, section.main);
            } else {
                this.colSection(section.main, 1, row, this.colsLength(obj));
            }
        }

        if (Object.keys(section.secondary).length && last < this.rowsTotal) {

            this.rowSection(section.secondary, ++last, col);

        } else if (this.lastRendered(section.main) && !col) {

            this.setAttributes(this.alignment.horizontal, this.alignment.vertical);

            if (this.layoutWidth !== 0) {
                this.updateColWidth(this.layoutWidth);
            }

            if (this.layoutImage) {
                this.appendImage();
            }

            if (this.layoutLargeComponent) {
                this.appendLargeComponent();
            }

            if (this.separator) {
                this.appendSeparator();
            }

        }
    };

    ContentLayout.prototype.appendLargeComponent = function() {
        var layoutLargeComponent = document.createElement('div');

        layoutLargeComponent.setAttribute('id', 'js-layout-large-component');
        layoutLargeComponent.setAttribute('class', 'layout-large-component');

        layoutLargeComponent.setAttribute('data-bind', 'template: { name: function() { return $root.layout.templateID(\'layout\', \'componentdefault\', \'ko-template-layout-componentdefault\'); } }');

        this.setMobileProp(layoutLargeComponent, 'componentdefault');

        this.container.appendChild(layoutLargeComponent);
    };

    ContentLayout.prototype.appendSeparator = function() {
        var sep = document.createElement('div'),
            pos = (this.layoutWidth !== 0) ? 50 + (this.layoutWidth/2) : 50;

        sep.setAttribute('class', 'separation-line');
        sep.style.left = pos + '%';

        if (this.container.firstChild) {
            this.container.insertBefore(sep, this.container.firstChild);
        } else {
            this.container.appendChild(sep);
        }
    };

    ContentLayout.prototype.appendImage = function() {
        var left = 0,
            right = 0,
            layoutRows = this.container.childNodes,
            layoutImage = document.createElement('div'),
            firstCol = this.firstPoint(this.layoutImage, 'col'),
            firstRow = this.firstPoint(this.layoutImage, 'row'),
            lastCol = this.lastPoint(this.layoutImage, 'col'),
            lastRow = this.lastPoint(this.layoutImage, 'row'),
            imageWidth = this.colsLength(this.layoutImage),
            imageHeight = this.rowsLength(this.layoutImage),
            suffix = (imageHeight === this.rowsTotal || (this.rowsTotal === 4 && imageHeight + 1 === this.rowsTotal)) ? 'full' : 'custom',
            layoutTemplate = (this.layoutTemplate) ? this.layoutTemplate.toLowerCase() : '';

        layoutImage.setAttribute('id', 'js-layout-image');
        layoutImage.setAttribute('class', 'layout-image');

        this.updateCol(layoutImage, 'image');

        if (imageWidth === this.colsTotal) {

            layoutImage.className += ' layout-image-' + suffix;

        } else if (firstCol > 1 && !this.singleColumn) {
            left = (this.colsTotal - firstCol + 1) * (100 / this.colsTotal);

            if (this.layoutWidth !== 0) {
                left += this.layoutWidth/2;
            }

            layoutImage.style.left = left + '%';
            layoutImage.setAttribute('data-left', left + '%');
            layoutImage.className += ' layout-image-' + suffix + '-right';

        } else if (lastCol < this.colsTotal) {
            right = (this.colsTotal - lastCol) * (100 / this.colsTotal);

            if (this.layoutWidth !== 0) {
                right -= this.layoutWidth/2;
            }

            layoutImage.style.right = right + '%';
            layoutImage.setAttribute('data-right', right + '%');
            layoutImage.className += ' layout-image-' + suffix + '-left';
        }

        if (imageHeight === this.rowsTotal || (this.rowsTotal === 4 && imageHeight + 1 === this.rowsTotal)) {

            if (layoutRows.length === 1) {
                this.container.appendChild(layoutImage);
            } else {
                if (layoutTemplate === 'textonright') {
                    this.container.insertBefore(layoutImage, this.container.firstChild);
                } else {
                    this.container.insertBefore(layoutImage, this.container.lastChild);
                }
            }
        } else {

            if (lastRow === this.rowsTotal) {
                layoutRows[layoutRows.length - 1].appendChild(layoutImage);
            } else if (firstRow === 1) {
                layoutRows[0].appendChild(layoutImage);
            } else {
                firstRow = (firstRow > this.rowsTotal) ? this.rowsTotal : firstRow;
                firstRow = (firstRow > 0) ? firstRow - 1 : firstRow;
                layoutRows[firstRow].appendChild(layoutImage);
            }

        }
    };

    ContentLayout.prototype.setAttributes = function(horizontal, vertical) {
        var i = 0,
            _this = this,
            contentCSS = 'layout-content',
            layoutRows = _this.container.childNodes,
            layoutLast = (layoutRows.length) ? layoutRows[layoutRows.length - 1] : null,
            len = layoutLast.childNodes.length,
            template = (_this.layoutTemplate) ? _this.layoutTemplate.toLowerCase() : '',
            asideColumnCSS = ' l-col-flex',
            contentColumnCSS = ' l-col-flex';

        if (!layoutLast) {
            return;
        }

        // Backwards compatibility
        if (vertical.aside) {
            switch(vertical.aside) {
            case 'align-top-aside':
                vertical.aside = 'l-align-top';
                break;
            case 'align-center-aside':
                vertical.aside = 'l-align-middle';
                break;
            case 'align-bottom-aside':
                vertical.aside = 'l-align-bottom';
                break;
            case 'align-stretch-aside':
                vertical.aside = 'l-align-stretch'
                break;
            default:
                break;
            }
        }

        if (vertical.content) {
            switch(vertical.content) {
            case 'align-top':
                vertical.content = ((_this.singleColumn) ? 'l-content-aligned ' : '') + 'l-align-top';
                break;
            case 'align-center':
                vertical.content = ((_this.singleColumn) ? 'l-content-aligned ' : '') + 'l-align-middle';
                break;
            case 'align-bottom':
                vertical.content = ((_this.singleColumn) ? 'l-content-aligned ' : '') + 'l-align-bottom';
                break;
            case 'align-stretch':
                vertical.content = 'l-align-stretch'
                break;
            default:
                break;
            }
        }
        // END Backwards compatibility

        if (_this.singleColumn) {

            if (vertical.content && vertical.content.indexOf('l-content-aligned') !== -1) {
                contentCSS += ' ' + vertical.content;
            }

            if (horizontal.content) {
                contentCSS += ' ' + horizontal.content;
            }

        } else {

            if (horizontal.content) {
                if (horizontal.content.indexOf('l-align-cols') !== -1) {

                    horizontal.content = horizontal.content.replace(/l-align-cols /, '');

                    for (i = 0; i < layoutRows.length; i++) {
                        layoutRows[i].childNodes[0].className += ' ' + horizontal.content;
                    }

                } else {

                    for (i = 0; i < layoutRows.length; i++) {
                        if (layoutRows[i].childNodes.length > 1) {
                            layoutRows[i].childNodes[0].className += ' ' + horizontal.content;
                        }
                    }

                }
            }

            if (horizontal.aside) {
                for (i = 0; i < layoutRows.length; i++) {
                    if (layoutRows[i].childNodes.length > 1) {
                        layoutRows[i].childNodes[1].className += ' ' + horizontal.aside;
                    }
                }
            }

            if (vertical.content && vertical.content.indexOf('l-content-aligned') !== -1) {

                if (vertical.content.indexOf('l-align-custom') !== -1) {
                    _this.setCustomLayout(_this.container);
                }

                if (layoutRows.length === 2) {
                    contentCSS += ' ' + vertical.content;
                }
            }

        }

        for (i = 0; i < layoutRows.length; i++) {
            layoutRows[i].className += ' l-row';
        }

        _this.container.className = contentCSS;

        if (!layoutLast.childNodes.length) {
            return;
        }

        if (vertical.content && vertical.content.indexOf('l-content-aligned') !== -1) {

            if (vertical.content.indexOf('l-align-bottom') !== -1 || vertical.content.indexOf('l-align-top') !== -1) {
                asideColumnCSS += ' ' + vertical.content.replace(/l-content-aligned /, '');
                contentColumnCSS += ' ' + vertical.content.replace(/l-content-aligned /, '');
            }

        } else {

            layoutLast.setAttribute('id', 'js-layout-flex');
            layoutLast.className += ' l-row-flex';

            switch(template) {
            case 'taskatbottom':
            case 'textonright':
            case 'extraonleft':

                contentColumnCSS += ' l-align-bottom';
                break;
            case 'taskonright':
            case 'largecomponent':
            case 'custom':

                break;
            case 'extraontop':

                asideColumnCSS += ' l-align-top';
                break;
            case 'centeredtitle':
                contentColumnCSS += ' l-align-middle';

                if (len > 1) {
                    asideColumnCSS += ' l-align-bottom';
                }

                break;
            default:
                // if (len > 1) {
                //     asideColumnCSS += ' l-align-bottom';
                // }
            }
        }

        this.setContainerCSS(layoutLast.childNodes[0], vertical.content, contentColumnCSS, layoutRows.length === 1);

        if (len < 2) {
            return;
        }

        this.setContainerCSS(layoutLast.childNodes[len - 1], vertical.aside, asideColumnCSS, layoutRows.length === 1);

        if (utils.isOldIE) {
            var IEcontent = vertical.content && vertical.content.indexOf('l-align-stretch') !== -1,
                IEaside = vertical.aside && vertical.aside.indexOf('l-align-stretch') !== -1

            if (IEcontent || IEaside) {
                _this.container.className += ' l-content-oldie';
                _this.setOldieCSS(layoutRows, IEcontent, IEaside);
            }
        }
    };

    ContentLayout.prototype.setOldieCSS = function(layoutRows, IEcontent, IEaside) {
        var first = layoutRows[0].childNodes || [],
            last = layoutRows[layoutRows.length - 1].childNodes || [];

        if (!IEcontent) {
            if (first.length) {
                first[0].className += ' l-oldie-top';
            }
            if (last.length) {
                last[0].className += ' l-oldie-bottom';
            }
        }

        if (!IEaside) {
            if (first.length && first.length > 1) {
                first[first.length - 1].className += ' l-oldie-top';
            }
            if (last.length && last.length > 1) {
                last[last.length - 1].className += ' l-oldie-bottom';
            }
        }
    };

    ContentLayout.prototype.setContainerCSS = function(container, alignCSS, columnCSS, custom) {

        if (alignCSS) {

            if (alignCSS.indexOf('l-align-custom') === -1 ||  custom) {
                container.className += ' l-col-flex ' + alignCSS;
            }

            if (alignCSS.indexOf('l-align-custom') !== -1 && custom) {
                this.setCustomLayout(container);
            }

        } else {
            container.className += columnCSS;
        }

    };

    ContentLayout.prototype.setCustomCSS = function(rows) {
        rows = rows || [];

        for (var i = 0; i < rows.length; i++) {
            rows[i].className += (i === 0) ? ' l-row-custom-top' : ' l-row-custom-bottom';
        }
    };

    ContentLayout.prototype.setCustomLayout = function(container) {
        var temporary = document.createDocumentFragment(),
            rows = container.childNodes;

        if (!rows) {
            return;
        }

        if (rows.length > 2) {
            var row = this.createRow(temporary),
                col = this.createColumn(row);

            for (var i = 1; i < rows.length; i++) {
                col.appendChild(rows[i].cloneNode(true));
            }

            while (rows.length > 1) {
                container.removeChild(rows[rows.length-1]);
            }

            container.appendChild(row);
        }

        if (rows.length === 2) {
            this.setCustomCSS(rows);
        }
    }

    ContentLayout.prototype.updateColWidth = function(layoutWidth) {
        var i,
            cols = null,
            childNodes = this.container.childNodes;

        for (i in childNodes) {
            if (childNodes.hasOwnProperty(i)) {
                cols = childNodes[i].childNodes;

                if (!cols || cols.length < 2) {
                    continue;
                }

                cols[0].style.width = (50 + layoutWidth/2) + '%';
                cols[1].style.width = (50 - layoutWidth/2) + '%';

                if (layoutWidth === 0) cols[0].className += ' hidden';
                if (layoutWidth === 100) cols[1].className += ' hidden';

            }
        }
    };

    ContentLayout.prototype.addEmptyCols = function(obj, colsTotal, rowsTotal) {
        var arr = [],
            empty = {},
            addCords = function(cords) {
                var str = '',
                    colFrom = cords[0][0],
                    colTill = cords[1][0],
                    rowFrom = cords[0][1],
                    rowTill = cords[1][1];

                for (var i = colFrom; i <= colTill; i++) {
                    for (var j = rowFrom; j <= rowTill; j++) {
                        str = i + '-' + j;
                        if (arr.indexOf(str) === -1) {
                            arr.push(str);
                        }
                    }
                }

            };

        for(var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                addCords(obj[prop]);
            }
        }

        if (colsTotal * rowsTotal <= arr.length) {
            return obj;
        }

        for (var m = 1; m <= colsTotal; m++) {
            for (var n = 1; n <= rowsTotal; n++) {
                if (arr.indexOf(m + '-' + n) === -1) {

                    if (empty[n]) {
                        empty[n].push(m);
                    } else {
                        empty[n] = [m];
                    }

                    if (empty[n].length === colsTotal) {
                        // remove empty rows
                        for (var col = 1; col <= colsTotal; col++) {
                            delete obj['e-' + col + '-' + n];
                        }
                    } else {
                        obj['e-' + m + '-' + n] = [[m,n], [m,n]];
                    }
                }
            }
        }

        return obj;
    };

    ContentLayout.prototype.formatMatrix = function(obj) {
        for(var i in obj) {
            if (obj.hasOwnProperty(i) && obj[i].length === 1) {
                obj[i] = [obj[i][0],obj[i][0]];
            }
        }

        return obj;
    };

    ContentLayout.prototype.appendProp = function(prop, obj) {
        var exist = false,
            colsTotal = 0,
            rowsTotal = 0;

        for(var i in obj) {
            if (obj.hasOwnProperty(i) && prop && i.toLowerCase() === prop.toLowerCase()) {
                exist = true;
                break;
            }
        }

        if (exist) {
            return obj;
        }

        colsTotal = this.lastPoint(obj, 'col');
        rowsTotal = this.lastPoint(obj, 'row');
        rowsTotal++;

        obj[prop] = [[this.firstPoint(obj, 'col'), rowsTotal], [colsTotal, rowsTotal]];

        return obj;
    };

    ContentLayout.prototype.removeProp = function(prop, obj) {
        for(var i in obj) {
            if (obj.hasOwnProperty(i) && prop && i === prop) {
                delete obj[i];
            }
        }

        return obj;
    };

    ContentLayout.prototype.repositionProp = function(prop, obj) {
        var colsTotal = 0,
            rowsTotal = 0;

        if (obj.hasOwnProperty(prop)) {
            obj = this.removeProp(prop, obj);
        }

        colsTotal = this.lastPoint(obj, 'col');
        rowsTotal = this.lastPoint(obj, 'row') + 1;

        obj[prop] = [[this.firstPoint(obj, 'col'), rowsTotal], [colsTotal, rowsTotal]];

        return obj;
    };

    ContentLayout.prototype.getChildNodes = function() {
        var i = 0,
            arr = [],
            childNodes = this.container.childNodes,
            len = childNodes.length;

        for( ; i < len; i++) {
            arr.push(childNodes[i]);
        }

        return arr;
    };

    ContentLayout.prototype.init = function() {
        var layoutTemplate = (this.layoutTemplate) ? this.layoutTemplate.toLowerCase() : '';

        this.singleColumn = this.singleColumn || (this.firstPoint(this.layoutElements, 'col') === this.lastPoint(this.layoutElements, 'col')) ? true : false;

        if (layoutTemplate === 'largecomponent') {

            if (this.imageURL === '') {
                this.layoutElements = this.removeProp('image', this.layoutElements);
            }

            if (this.layoutElements.componentDefault) {
                this.layoutLargeComponent = {'largeComponent': this.layoutElements.componentDefault.slice(0)};
            }
            this.layoutElements = this.removeProp('componentDefault', this.layoutElements);

            this.colsTotal = this.lastPoint(this.layoutElements, 'col');
            this.rowsTotal = this.lastPoint(this.layoutElements, 'row');

        } else {

            if (this.missing) {
                this.layoutElements = this.appendProp('componentdefault', this.layoutElements);
            }

            this.colsTotal = this.lastPoint(this.layoutElements, 'col');
            this.rowsTotal = this.lastPoint(this.layoutElements, 'row');

            if (this.imageURL === '') {
                this.layoutElements = this.removeProp('image', this.layoutElements);
            }
        }

        if (this.imageURL !== '' && Array.isArray(this.layoutElements.image)) {
            this.layoutImage = {'image': this.layoutElements.image.slice(0)};
            this.layoutElements = this.removeProp('image', this.layoutElements);

            if (!Object.keys(this.layoutElements).length) {
                this.layoutElements = this.formatMatrix(this.layoutImage);
            }
        }

        if (Object.keys(this.layoutElements).length) {
            this.layoutElements = this.formatMatrix(this.layoutElements);
        }

        if (!this.singleColumn) {
            this.layoutElements = this.addEmptyCols(this.layoutElements, this.colsTotal, this.rowsTotal);
        }

        this.rowSection(this.layoutElements, 1);
    };

    return ContentLayout;

});

